export function initHeaderHints() {
    const hintsHelpBtn = $('.page__hints-item--help');

    hintsHelpBtn.on('click', (e) => {
        e.preventDefault();
        hintsHelpBtn.siblings('.page__hints-hidden').toggleClass('opened');
        hintsHelpBtn.toggleClass('opened');
    });

    const scrollCatalogHandler = () => {
        const hintsBlock = document.querySelector('.page__hints-block');

        if (!hintsBlock) return;

        if (window.pageYOffset >= 200) {
            hintsBlock.classList.add('show');
            return false;
        }

        hintsBlock.classList.remove('show');
        return false;
    };

    document.addEventListener('scroll', scrollCatalogHandler);
}
